import React, { Component } from 'react'
import firebase from 'firebase';
import './scss/GoogleLogin.scss';
import GoogleIcon from '../../svg/Social/GoogleIcon';
import { firebaseInitStatus, loadFireBase } from '../../../util/firebaseUtils';
import { showNotification } from '../../../util/notification';
import { debugLog } from '../../../util/logUtils';

export class GoogleLogin extends Component {

	constructor(props) {
		super(props);
		if (!firebaseInitStatus) {
			loadFireBase();
		}
		this.googleProvider = new firebase.auth.GoogleAuthProvider();

	}

	authHandler = () => {
		if(firebaseInitStatus && firebase){
			firebase.auth().signInWithPopup(this.googleProvider).then((result) => {
				this.props.onAuth(result);
	
			}).catch((error) => {
				showNotification({ text: "Unable to connect to gmail account." })
			});
		}else {
			debugLog("load firebase failed.")
		}
	}

	render() {
		const data = this.props.data || {},
			label = data.label || "";
		return (
			<div className="fb-google-login-button" onClick={this.authHandler}>
				<GoogleIcon />
				{label}
			</div>
		);
	}
}

export default GoogleLogin;
